import { getPack, type Certainty, type ItemResult, type PackId } from './packs/registry';

const conditional = /(협의|변동|별도\s*가능|현장|추가될\s*수|~|〜|-\s*\d+\s*만)/i;
const included = /(포함|무료|서비스)/i;
const excluded = /(별도)/i;

export function parseAmount(text: string): number | null {
  if (conditional.test(text)) return null;
  const match = text.replaceAll(',', '').match(/(\d+(?:\.\d+)?)\s*(만원|천원|만|천|원)/);
  if (!match) return null;
  const value = Number(match[1]);
  const amount = ['만원','만'].includes(match[2]) ? value * 10_000 : ['천원','천'].includes(match[2]) ? value * 1_000 : value;
  return Number.isInteger(amount) && amount >= 0 && amount <= 100_000_000 ? amount : null;
}

export function certaintyFor(text: string | null, confidence = 1): { certainty: Certainty; amountKrw: number | null } {
  if (!text?.trim()) return { certainty: 'missing', amountKrw: null };
  if (conditional.test(text)) return { certainty: 'conditional', amountKrw: null };
  if (confidence < 0.65) return { certainty: 'unreadable', amountKrw: null };
  const amountKrw = parseAmount(text);
  if (excluded.test(text) && amountKrw !== null) return { certainty: 'excluded_amount', amountKrw };
  if (amountKrw !== null) return { certainty: 'confirmed_amount', amountKrw };
  if (/\d{4}[-./]\d{1,2}[-./]\d{1,2}|\d{1,2}시|\d+시간/.test(text)) return {certainty:'included',amountKrw:null};
  if (included.test(text)) return { certainty: 'included', amountKrw: null };
  return { certainty: 'missing', amountKrw: null };
}

export function analyzeText(text: string, packId: PackId = 'moving'): ItemResult[] {
  const lines = text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
  return getPack(packId).checklist.map((item) => {
    const labels = [item.label, ...item.aliases];
    const sourceText = lines.find((line) => labels.some((label) => line.toLowerCase().includes(label.toLowerCase()))) ?? null;
    return { itemId: item.id, ...certaintyFor(sourceText), sourceText, confidence: sourceText ? 0.9 : 1, userEdited: false };
  });
}

export const unresolvedCount = (items: ItemResult[]) => items.filter((item) => ['missing','conditional','unreadable'].includes(item.certainty)).length;

export function itemReason(item:ItemResult){if(!item.sourceText)return '견적에 표기가 없어요';if(item.certainty==='missing'&&/별도/.test(item.sourceText))return '별도라고만 적혀 있고 금액이 없어요';if(item.certainty==='conditional')return '적용 조건이나 금액을 더 물어봐요';if(item.certainty==='unreadable')return '글자를 다시 확인해 주세요';return '이 줄에 적혀 있어요';}
